import React from 'react'

const ReportsPage = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Reports Page</h1>
      <p>This is a placeholder for the Reports page.</p>
    </div>
  )
}

export default ReportsPage